import { FormStatusType, IEConsentForm } from "@/api/dtos";
import { EConsentUserType } from "@/contexts/EConsentContext";
import { IFormInformation } from "@ngt/opms";
import { isFunction } from "lodash-es";
import { useMemo } from "react";


const useEConsentFormReadOnly = <TFormValue extends IEConsentForm>(
    userType?: EConsentUserType | null,
    initialValue?: TFormValue,
    readOnly?: boolean | ((info: IFormInformation<TFormValue>) => boolean)
) => {
    const formReadOnly = useMemo(() => {
        const readOnlyValue = isFunction(readOnly) ? readOnly({ initialValue }) : readOnly;
    
        if (readOnlyValue === true) {
            return true;
        }

        if ((initialValue as { formStatus?: FormStatusType } | undefined)?.formStatus === FormStatusType.Locked) {
            return true;
        }

        return (!!initialValue?.patientSignedConsent && userType === EConsentUserType.Participant) || 
            (!!initialValue?.investigatorSignedConsent && userType === EConsentUserType.Investigator);

    }, [readOnly, initialValue, userType])

    return formReadOnly;
}

export default useEConsentFormReadOnly;
